import { Outlet, createRootRoute, HeadContent } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

import { Sorry } from '@/features/registration';
import { isRouterDevToolsEnabled } from '@/globalConsts';

export const Route = createRootRoute({
	component: () => (
		<>
			<HeadContent />
			<Outlet />
			{isRouterDevToolsEnabled && <TanStackRouterDevtools position='bottom-right' />}
		</>
	),
	notFoundComponent: () => <Sorry />,
	head: () => ({
		meta: [
			{
				name: 'description',
				content: 'Making research accessible for everyone.',
			},
			{
				title: 'ACCESS Research Platform',
			},
		],
	}),
});
